/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Roster_SinceInputs */

const th_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ตั้งแต่ ${i?.date}`)
};

const en_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Since ${i?.date}`)
};

const ja_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}から`)
};

const zh_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自 ${i?.date} 起`)
};

const es_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde ${i?.date}`)
};

const pt_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde ${i?.date}`)
};

const id_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sejak ${i?.date}`)
};

const fr_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Depuis le ${i?.date}`)
};

const tl_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Simula ${i?.date}`)
};

const vi_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.date}`)
};

const ko_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}부터`)
};

const de_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seit ${i?.date}`)
};

const ru_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`С ${i?.date}`)
};

const tr_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} tarihinden beri`)
};

const it_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dal ${i?.date}`)
};

const pl_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.date}`)
};

const uk_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Від ${i?.date}`)
};

const hi_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} से`)
};

const ar_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`منذ ${i?.date}`)
};

const ms_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sejak ${i?.date}`)
};

const bn_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} থেকে`)
};

const zh_tw2_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自 ${i?.date} 起`)
};

const zh_hk2_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自 ${i?.date} 起`)
};

const ur_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} سے`)
};

const fa_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`از ${i?.date}`)
};

const sw_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tangu ${i?.date}`)
};

const nl_roster_since = /** @type {(inputs: Roster_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sinds ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Since {date}" |
*
* @param {Roster_SinceInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const roster_since = /** @type {((inputs: Roster_SinceInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_SinceInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_roster_since(inputs)
	if (locale === "ja") return ja_roster_since(inputs)
	if (locale === "zh") return zh_roster_since(inputs)
	if (locale === "es") return es_roster_since(inputs)
	if (locale === "pt") return pt_roster_since(inputs)
	if (locale === "id") return id_roster_since(inputs)
	if (locale === "fr") return fr_roster_since(inputs)
	if (locale === "tl") return tl_roster_since(inputs)
	if (locale === "vi") return vi_roster_since(inputs)
	if (locale === "ko") return ko_roster_since(inputs)
	if (locale === "de") return de_roster_since(inputs)
	if (locale === "ru") return ru_roster_since(inputs)
	if (locale === "tr") return tr_roster_since(inputs)
	if (locale === "it") return it_roster_since(inputs)
	if (locale === "pl") return pl_roster_since(inputs)
	if (locale === "uk") return uk_roster_since(inputs)
	if (locale === "hi") return hi_roster_since(inputs)
	if (locale === "ar") return ar_roster_since(inputs)
	if (locale === "ms") return ms_roster_since(inputs)
	if (locale === "bn") return bn_roster_since(inputs)
	if (locale === "zh-TW") return zh_tw2_roster_since(inputs)
	if (locale === "zh-HK") return zh_hk2_roster_since(inputs)
	if (locale === "ur") return ur_roster_since(inputs)
	if (locale === "fa") return fa_roster_since(inputs)
	if (locale === "sw") return sw_roster_since(inputs)
	if (locale === "nl") return nl_roster_since(inputs)
	return en_roster_since(inputs)
});